import React, { useEffect } from "react";

import { client_v2 } from "utils/api";

import { PageLoader } from "components";

const OmsOrderRedirect = ({
  history,
  match: {
    params: { oms_order_id },
  },
}) => {
  useEffect(() => {
    getOmsOrder()
      .then(({ id }) => {
        history.push(`/gdns/${id}`);
      })
      .catch((err) => {
        history.push("/gdns");
      });
  }, [oms_order_id]);

  const getOmsOrder = async () => {
    const {data} = await client_v2.get(
      `/gdns/find_by_oms_order_id?oms_order_id=${oms_order_id}`,
    );
    return data;
  };

  return <PageLoader />;
};

export default OmsOrderRedirect;
